import { getStorage, ref, uploadBytes } from 'firebase/storage';

import { ensureOnline } from '@/libs/network';
import { getFirebaseApp } from '../init.web';

export const uploadImageToStorage = async (filePath: string, storagePath: string) => {
  await ensureOnline();
  const res = await fetch(filePath);
  const blob = await res.blob();
  const storage = getStorage(getFirebaseApp());
  const storageRef = ref(storage, storagePath);
  return uploadBytes(storageRef, blob, { contentType: blob.type || 'image/jpeg' });
};
